import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useDispatch, useSelector } from 'react-redux';

import { PromoItemContainer } from '../PromoItemContainer';
import { Promos } from '../../components/Promos';
import { newbuildingIdSelector, promosSelector } from '../../selectors/newbuilding';
import { FlatsError } from '../../components/FlatsError';
import { trackClickPromoBlock, trackPromoOffersShow } from '../../analytics/promos';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';
import { TDispatch } from '../../types/redux';
import { openPromo } from '../../slices';

export const DesktopPromosSection: React.FC = () => {
  const dispatch: TDispatch = useDispatch();

  const promos = useSelector(promosSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);

  const onPromoClick = React.useCallback(
    (promo: IPromoInfo) => {
      dispatch(openPromo(promo));
      trackClickPromoBlock(promo, newbuildingId);
    },
    [dispatch, newbuildingId],
  );

  const onBlockShow = React.useCallback(() => {
    trackPromoOffersShow(promos, newbuildingId);
  }, [promos, newbuildingId]);

  if (promos.length === 0) {
    return <FlatsError />;
  }

  return (
    <ActionAfterViewObserver callback={onBlockShow} triggerOnce>
      <Promos>
        {promos.map(promo => (
          <PromoItemContainer key={promo.uniquePromoId} promo={promo} onClick={onPromoClick} />
        ))}
      </Promos>
    </ActionAfterViewObserver>
  );
};
